import { Cookies } from 'react-cookie';

import { Vulnerability } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getObjectVuls = async (slug: string, filter: string = 'default') => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/objects/${slug}/vulnerabilities/`, {
    headers: {
      Authorization: token,
    },
    params: {
      filter: filter,
    },
  });

  return data.data as Vulnerability[];
};
